import React, { Component } from 'react';
import { defaultMenuSelection } from '../../helpers/menuSelection';
import MenuSelectionCard from './MenuSelectionCardNew';
import DrawerHeader from './DrawerHeader';
import { maskServiceDateNoDay } from '../../masks.js';
import DrawerSlideWrapper from './DrawerSlideWrapper';
import Spinner from '../shared/Spinner';

class MenuSelectionNew extends Component {
  state = {
    menu: {},
    favoritedDishes: [],
    evergreenMenus: [],
    menuIndexSelected: 0,
    isOnboarding: false,
    isScrolledToTop: true,
  };

  render() {
    const { handleClose, menuStartTime, isOpen } = this.props;
    const {
      menu,
      favoritedDishes,
      evergreenMenus,
      menuIndexSelected,
      isOnboarding,
    } = this.state;

    const { courses = [] } = this.state.menu;
    const { isScrolledToTop } = this.state;

    const menuOptions = [
      { name: 'Weekly', menu: menu },
      { name: 'My Favorites', menu: favoritedDishes },
      ...evergreenMenus.map((menu) => {
        return {
          name: menu.name || '',
          menu: menu,
        };
      }),
    ];

    if (isOnboarding) menuOptions.splice(1, 1);

    return (
      <DrawerSlideWrapper
        isOpen={isOpen}
        isLeft={true}
        isScrolledToTop={isScrolledToTop}
      >
        <DrawerHeader
          title="Menu Selection"
          handleClose={handleClose}
          subtitle={`Weekly Service ${
            maskServiceDateNoDay(menuStartTime) || ''
          }`}
        >
          <div className="menus-screen__nav-list-wrap">
            <ul className="menus-screen__nav-list">
              {menuOptions.map((option, ix) => {
                const classes =
                  menuIndexSelected !== ix
                    ? 'menus-screen__menu-button'
                    : 'menus-screen__menu-button--selected';
                return (
                  <li className="menus-screen__nav-item" key={option.menu.id}>
                    <button
                      className={classes}
                      onClick={() => this.handleClickMenu(ix)}
                    >
                      {option.name}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </DrawerHeader>
        {menuIndexSelected === 0 && (
          <div className="menu-selection-new">
            {courses.length ? (
              <ul>{courses.map((course) => this.renderCourse(course))}</ul>
            ) : (
              <Spinner isRequestOut={true} />
            )}
          </div>
        )}

        {!isOnboarding && menuIndexSelected === 1 && this.renderMyFavorites()}

        {evergreenMenus.length > 0 && this.renderEvergreenMenus()}
      </DrawerSlideWrapper>
    );
  }

  renderCourse(course) {
    const { dishes = [] } = course;
    const {
      updateMenuSelection,
      handleCustomizeDish,
      menuStartTime,
      client,
      menuSelections,
      favoritedDishIds,
      favoriteDish,
      unfavoriteDish,
    } = this.props;

    return (
      <li key={course.id} className="menu-selection-new__course">
        <div className="menu-selection-new__course-name-wrap">
          <div className="menu-selection-new__course-name-wrap--inner">
            <h3 className="menu-selection-new__course-name">{course.name}</h3>
          </div>
        </div>
        <ul className="menu-selection-new__cards">
          {dishes &&
            dishes.map((dish) => {
              const index = menuSelections.findIndex(
                (selection) => selection.menu_dish_id === dish.id
              );
              return (
                <li key={`${dish.id}${menuStartTime}${index}`}>
                  <MenuSelectionCard
                    dish={dish}
                    index={index}
                    className="menu-selection-card-new menu-selection-card-new--full-width"
                    menuSelection={
                      index >= 0
                        ? menuSelections[index]
                        : defaultMenuSelection(dish)
                    }
                    updateMenuSelection={updateMenuSelection}
                    handleCustomizeDish={handleCustomizeDish}
                    client={client}
                    favoritedDishes={favoritedDishIds}
                    favoriteDish={favoriteDish}
                    unfavoriteDish={unfavoriteDish}
                  />
                </li>
              );
            })}
        </ul>
      </li>
    );
  }

  renderMyFavorites = () => {
    const {
      client,
      updateFavMenuSelection,
      handleCustomizeDish,
      favoriteDish,
      unfavoriteDish,
      favoritedDishes,
      favoritedDishIds,
    } = this.props;
    if (favoritedDishes && favoritedDishes.length) {
      return (
        <div className="menus-screen__favorites">
          <ul className="menu-selection-new__cards">
            {favoritedDishes.map((menuSelection, ix) => {
              const { dish } = menuSelection;
              return (
                <li key={`${dish.id}-fav`}>
                  <MenuSelectionCard
                    dish={dish}
                    index={ix}
                    className="menu-selection-card-new menu-selection-card-new--full-width"
                    menuSelection={menuSelection}
                    updateMenuSelection={updateFavMenuSelection}
                    handleCustomizeDish={handleCustomizeDish}
                    client={client}
                    favoritedDishes={favoritedDishIds}
                    favoriteDish={favoriteDish}
                    unfavoriteDish={unfavoriteDish}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      );
    } else {
      return (
        <div className="menus-screen__no-favorites">
          <div className="menus-screen__no-favorites-card">
            <h1 className="menus-screen__no-favorites-headline">
              You currently have no<br></br> favorite dishes.
            </h1>
            <p className="menus-screen__no-favorites-copy">
              You can favorite a dish from any menu{' '}
            </p>
          </div>
        </div>
      );
    }
  };

  renderEvergreenMenus = () => {
    const { evergreenMenus, menuIndexSelected, isOnboarding } = this.state;

    return evergreenMenus.map(({ courses = [] }, ix) => {
      // If onboarding offset by 1.  Else 2
      const offset = isOnboarding ? 1 : 2;
      const index = ix + offset;

      return (
        index === menuIndexSelected && (
          <div className="menu-selection-new">
            {courses.length ? (
              <ul>{courses.map((course) => this.renderCourse(course))}</ul>
            ) : (
              <Spinner isRequestOut={true} />
            )}
          </div>
        )
      );
    });
  };

  handleClickMenu = (ix) => {
    // Select menu and sets prop passed to drawer slide wrapper to scroll back to top when switching menus
    this.setState({ menuIndexSelected: ix, isScrolledToTop: true });

    // reset Scrolled to Top
    setTimeout(() => this.setState({ isScrolledToTop: false }), 100);
  };

  componentDidUpdate(prevProps) {
    const { menu, evergreenMenus, favoritedDishIds, favoritedDishes } =
      this.props;

    if (prevProps.menu !== menu) {
      this.setState({
        menu,
        menuIndexSelected: 0, // opens with "Weekly" menu selected
      });
    }

    if (prevProps.favoritedDishes !== favoritedDishes)
      this.setState({ favoritedDishes });

    if (prevProps.favoritedDishIds !== favoritedDishIds)
      this.setState({ favoritedDishIds });

    if (prevProps.evergreenMenus !== evergreenMenus)
      this.setState({ evergreenMenus });
  }

  componentDidMount() {
    const { favoritedDishes, favoritedDishIds, menu, evergreenMenus } =
      this.props;

    const isOnboarding = window.location.pathname.includes('new-client');

    this.setState({
      favoritedDishes,
      favoritedDishIds,
      menu,
      evergreenMenus,
      isOnboarding,
    });
  }
}

export default MenuSelectionNew;



// WEBPACK FOOTER //
// ./src/components/new/MenuSelectionNew.js